<!-- H5流程，详情页面 -->
<template lang="pug">
.startflow(v-loading="loading" element-loading-text="数据处理中...")
  .topTitle
    .titleTop
      span.flowTitle {{ flowTitle }}
      flowStatus(:status="flowInfo.status")
    .titleBottom {{ flowInfo.flowInstanceStartTime }}
  .titleRow 基本信息
  component.approvalH5(
    ref="businessForm"
    :is="basicForm"
    :flowMessage="flowInfo"
    :prjId="approvalPrjId"
    :flowDefinitionId="flowDefinitionId"
    :formId="formId"
    :uuid="uuid"
    :key="comKey"
    flowModeStatus="approve"
    flowLayoutType="H5"
    @hook:mounted="onFlowFormLoad"
    @loadComplete="loadComplete"
  )
  //- 兼容代码组件使用上传的展示文件列表，后期建议抛弃
  viewFileH5(ref="viewFileH5",:uuid="uuid", :flowKey="flowInfo.flowKey", noDelete, v-if="!isLowCode")
  template(v-if="fileList.length")
    .uploaderTitle 流程模板附件
    defaultFileView(ref="defaultFileView",:uuid="uuid", :files="fileList", noDelete)
  .flowShowNodes(v-if="nodeList.length>0")
    .titleRow(style="line-height: 50px") 审批节点
    flowNodesNew(ref="flowNodesNew" :uuid="uuid" source="h5" :getBasicData="getBasicData" @closeDialog="closeDialog")
</template>

<script>
import customVform from "@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue";
import viewFileH5 from "@/CommonDP/components/processComponents/flowNewConfig/viewFileH5.vue";
import defaultFileView from "@/CommonDP/components/processComponents/flowNewConfig/defaultFileView.vue";
import flowStatus from "@/CommonDP/components/flowComponents/flowStatus.vue";
import flowNodesNew from "@/CommonDP/components/processComponents/flowNewConfig/flowNodesNew.vue";
import { flowDetailMixins } from "@/CommonDP/components/processComponents/flowNew/mixins.js";
export default {
  components: { customVform, viewFileH5, defaultFileView, flowStatus, flowNodesNew },
  mixins: [flowDetailMixins],
  props: {
    // 唯一标识
    uuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      basicForm: "",
      floderData: [], // 附件
      showSteps: true,
      comKey: 0,
      approvalPrjId: ""
    };
  },
  computed: {
    formId() {
      return (this.flowInfo.formApproveH5Code || this.flowInfo.formH5Code) || (this.flowInfo.formApprovePcCode || this.flowInfo.formCode);
    },
    // 流程详情的标题
    flowTitle() {
      return this.flowInfo.flowInstanceOwnerName + "发起的" + (this.flowInfo.businessName || "流程");
    }
  },
  mounted() {
    this.addInit(true);
  },
  methods: {
    clickLeft() {
      this.$router.back();
    },
    // 获取基本信息数据
    getBasicData() {
      return this.$refs.businessForm.getFormData();
    }
  }
};
</script>

<style lang="scss" scoped>
.startflow {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .approvalH5 {
    padding: 5px;
    background-color: #fff;
  }
  .flowShowNodes {
    width: 100%;
    background-color: #fff;

  }
}
::v-deep .el-row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.topTitle {
  width: 100%;
  padding: 5px 10px;
  background-color: #fff;

  .titleTop {
    width: 100%;
    padding: 5px 0;
    display: flex;
    align-items: center;

    .flowTitle {
      width: 1px;
      flex-grow: 1;
      margin-right: 10px;
      white-space: pre-wrap;
      font-size: 16px;
      line-height: 20px;
      color: var(--key-color);
      font-weight: bold;
    }
  }
  .titleBottom {
    white-space: nowrap;
  }
}

.titleRow {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  padding: 0 10px;
  background-color: #fff;
  line-height: 40px;
  font-weight: bold;
  font-size: 15px;
  color: var(--key-color);
}

.uploaderTitle {
  height: 40px;
  padding: 0 10px;
  background: #fff;
  line-height: 45px;
  font-weight: 600;
  font-size: 15px;
}
</style>
